import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HomeExclusive() {
  const sliderRef = useRef(null);
  const [progress, setProgress] = useState(0);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,     
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    cssEase: "ease",
    responsive: [
        // {
        //     breakpoint: 2560,
        //     settings: { slidesToShow: 3,}
        // },
        // {
        //     breakpoint: 1440,
        //     settings: { slidesToShow: 2,}
        // },
        {
            breakpoint: 599,
            settings: { slidesToShow: 1,}
        },
    ],
    beforeChange: (oldIndex, nextIndex) => {
      // get total slides directly from the slider ref to avoid timing issues
      let totalSlides = 0;
      try {
        totalSlides =
          sliderRef.current &&
          sliderRef.current.innerSlider &&
          sliderRef.current.innerSlider.props &&
          sliderRef.current.innerSlider.props.children
            ? sliderRef.current.innerSlider.props.children.length
            : 0;
      } catch (e) {
        totalSlides = 0;
      }

      if (totalSlides <= 1) {
        setProgress(0);
        return;
      }

      const calc = (nextIndex / (totalSlides - 1)) * 100;
      setProgress(calc);
    },
  };

  const handlePrev = () => sliderRef.current && sliderRef.current.slickPrev();
  const handleNext = () => sliderRef.current && sliderRef.current.slickNext();


  return (
    <>
    <section className="home-exclusive">
        <h4 className="heading center-heading">Our Exclusive Signature Collections</h4>
        
        <Slider {...settings} ref={sliderRef}>
            <div>
                <div className="exclusive-slider">
                    <img src="/image/exclusive-slide-1.webp" className="img-responsive" alt="exclusive" loading="lazy"/>
                    <div>
                        <h4 className="heading">Banno</h4>
                        <p>Royal Grace, Redefined Always</p>
                        <Link to={"/wedding-dress-designers"} className="default-btn">Know More</Link>
                    </div>
                </div>
            </div>

            <div>
                <div className="exclusive-slider">
                    <img src="/image/exclusive-slide-2.webp" className="img-responsive" alt="exclusive" loading="lazy"/>
                    <div>
                        <h4 className="heading">Kanak</h4>
                        <p>Wrapped in Haldi Radiance</p>
                        <Link to={"/haldi-dresses"} className="default-btn">Know More</Link>
                    </div>
                </div>
            </div>

            <div>
                <div className="exclusive-slider">
                    <img src="/image/exclusive-slide-3.webp" className="img-responsive" alt="exclusive" loading="lazy"/>
                    <div>
                        <h4 className="heading">Anjum</h4>
                        <p>Celebrating Patterns of Love</p>
                        <Link to={"/mehandi-dresses"} className="default-btn">Know More</Link>
                    </div>
                </div>
            </div>
            
            <div>
                <div className="exclusive-slider">
                    <img src="/image/exclusive-slide-4.webp" className="img-responsive" alt="exclusive" loading="lazy"/>
                    <div>
                        <h4 className="heading">Ada</h4>
                        <p>Style Set to Rhythm</p>
                        <Link to={"/sangeet-suit"} className="default-btn">Know More</Link>
                    </div>
                </div>
            </div>
        </Slider>

        <div className="exclusive-controls">
            <div className="slider-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={Math.round(progress)} style={{
                backgroundSize: `${progress}% 100%`,
                transition: `background-size ${settings.speed}ms ease`, }}>
                <span className="slider__label sr-only">
                    {/* {Math.round(progress)}% completed */}
                </span>
            </div>
        </div>

        <div className="default-arrowleft" onClick={handlePrev}><Icons name="arrowLeft" /></div>
        <div className="default-arrowright" onClick={handleNext}><Icons name="arrowRight" /></div>
    </section>
    </>
  )
}
